/* eslint-disable max-len */
export default {
  // AlimTalk Template
  search: '템플릿 검색',
  name: '템플릿명 입력',
  register: '템플릿 등록',
  tableChanel: '채널',
  tableTemplateName: '템플릿명',
  tableStatus: '등록상태',
  tableCreateDate: '등록일시',
  tableDetails: '상세',
  stateCaption: [
    '등록 : 템플릿을 등록한 상태',
    '진행중 : 템플릿 등록 후, 승인을 기다리는 상태',
    '*상태가 진행중일때, 템플릿을 수정할 수 없으며, \'승인\' 이후 수정이 가능해진다.',
    '승인 : 검수 요청 후, 승인이 완료된 상태',
    '반려 : 검수 시 문제가 있어 반려된 상태',
  ],
  registerIcon: '템플릿 등록 아이콘',
  information2: '(새로운 템플릿 추가 등록 요망)',
  outgoingProfile: '발신 프로필',
  category: '카테고리',
  securityTemplateSettings: '보안 템플릿 설정',
  securityCaption: '보안 템플릿 체크 시, 메인 디바이스 모바일 외 모든 서브 디바이스에서는 메시지 내용이 노출되지 않습니다.',
  securityCaptionNo: '아이템리스트형은 보안 템플릿 설정을 할 수 없습니다.',
  templateName: '템플릿명',
  upTo25Placeholder: '최대 25자',
  messageType: '메시지 유형',
  messageBasic: '기본형',
  messageAdditionalInformation: '부가 정보형',
  messageChannelAddition: '채널 추가형',
  messageCompound: '복합형',
  emphasizeType: '강조 유형',
  notSelected: '선택 안함',
  text: '강조표기형',
  image: '이미지형',
  itemList: '아이템리스트형',
  emphasisTitle: '강조표기 타이틀',
  upTo50Placeholder: '최대 50자',
  upToPlaceholder: '최대 {count}자',
  emphasisAssistant: '강조표기 보조문구',
  imageLabel: '이미지',
  selectFile: '파일선택',
  filePlaceholder: '파일을 선택해주세요.',
  imageSize1: '제한 사이즈 : 가로 500px, 세로 250px 이하 / 가로:세로 비율이 2:1이 아닌 경우 등록 불가',
  imageSize2: '파일 형식 및 크기 : jpg, png / 최대 500KB',
  imageUse: '이미지 사용',
  header: '헤더',
  headerUse: '헤더 사용',
  headerTitle: '헤더 타이틀',
  headerPlaceholder: '16자 이내, 변수 입력 가능',
  itemHighlight: '아이템 하이라이트',
  itemHighlightUse: '아이템 하이라이트 체크 시, 하이라이트 타이틀 및 내용 설정이 필수 입니다.',
  itemTitle: '타이틀',
  itemTitlePlaceholder: '{count}자 이내, 변수 입력 가능',
  itemTitlePlaceholder1: '30자 이내, 변수 입력 가능',
  itemTitlePlaceholder2: '21자 이내, 변수 입력 가능',
  itemContent: '내용',
  itemContentPlaceholder1: '19자 이내, 변수 입력 가능',
  itemContentPlaceholder2: '13자 이내, 변수 입력 가능',
  itemHighlightImageUse: '아이템 하이라이트 이미지 사용 / 썸네일을 추가하면 아이템 하이라이트 타이틀은 21자, 내용은 13자까지 입력 가능합니다.',
  itemHighlightImageSize1: '제한 사이즈 : 가로 108px 이상 / 가로:세로 비율이 1:1이 아닌 경우 등록 불가',
  itemListLabel: '아이템 리스트',
  addBtn: '추가',
  deleteBtn: '삭제',
  itemListName: '아이템 명',
  itemListNamePlaceholder: '6자 이내, 변수 입력 불가',
  itemListContent: '아이템 내용',
  itemListContentPlaceholder: '23자 이내, 변수 입력 가능',
  itemListDelete: '삭제여부',
  itemSummary: '아이템 요약정보',
  itemSummaryUse: '아이템 요약정보 사용',
  itemSummaryTitle: '정보 타이틀',
  itemSummaryTitlePlaceholder: '6자 이내, 변수 입력 불가',
  itemSummaryContent: '정보 내용',
  itemSummaryContentPlaceholder: '14자 이내 변수/숫자/화폐 단위 (ex. 1,000, 5.0$, #{가격}원)',
  templateContent: '템플릿 내용',
  upTo1000Placeholder: '최대 1,000자',
  additionalInformation: '부가 정보',
  upTo500Placeholder: '최대 500자',
  addChannelMessage: '채널 추가 안내 메시지',
  addChannelMessagePlaceholder: '채널 추가하고 이 채널의 광고와 마케팅 메시지 받기',
  addChannelMessageCaption1: '메시지 유형이 "채널 추가형" 혹은 "복합형"인 경우 "채널 추가"버튼이 필수이며, 메시지 하단에 채널 추가 안내 메시지가 함께 노출됩니다.',
  addChannelMessageCaption2: "단, 발송 시점에 이미 채널을 추가한 수신자에게는 '채널 추가' 버튼과 안내 메시지가 표시되지 않습니다.",
  button: '버튼',
  buttonType: '버튼타입',
  buttonName: '버튼명',
  buttonLink: '버튼링크',
  buttonDelete: '삭제여부',
  buttonCaption: '버튼은 좌측에 추가버튼 클릭을 통해 노출할 수 있습니다.',
  modifyBtn: '수정',
  registerBtn: '등록',
  inspectionBtn: '검수 요청',
  transferTemplateBtn: '템플릿 이관',
  alimTalkArrived: '알림톡 도착',
  addChannelBtn: '채널 추가',
  delivery: '배송조회',
  webLink: '웹링크',
  appLink: '앱링크',
  messageDelivery: '메시지 전달',
  upTo14Placeholder: '최대 14자',
  buttonMaxLength: '버튼은 최대 5개까지 추가 가능합니다.',
  deliveryPageCaption: '알림톡 메시지 파싱을 통해 각 택배사에서 제공하는 배송 조회 페이지로 이동합니다.',
  mobilePlaceholder: 'Mobile 링크 입력',
  pcPlaceholder: 'PC 링크 입력',
  androidPlaceholder: 'Android 링크 입력',
  iosPlaceholder: 'iOS 링크 입력',
  imgSize500W: '이미지의 가로 크기가 500px보다 작습니다.',
  imgSize250H: '이미지의 세로 크기가 250px보다 작습니다.',
  imgratio21: '가로:세로 비율은 2:1여야 합니다.',
  imgSize108W: '이미지의 가로 크기가 108px보다 작습니다.',
  imgSize108H: '이미지의 세로 크기가 108px보다 작습니다.',
  imgratio1: '가로:세로 비율은 1:1여야 합니다.',
  differentExtensions: '확장자가 다릅니다.',
  fileSize500: '파일 크기가 500KB보다 큽니다.',
  itemButtonMaxLength: '버튼은 최대 10개까지 추가 가능합니다.',
  information1: '‘검수 중’, ‘승인‘ 상태인 템플릿은 수정 및 삭제가 불가합니다. 필요 시 신규 템플릿을 등록하세요.',
  information3: '‘임시 저장’ 상태의 템플릿은 조회 화면에서 수정할 수 있습니다.',
  information4: '‘임시 저장‘ 상태의 템플릿은 조회 화면에서 검수요청을 클릭해야 정상적으로 카카오 검수 요청이 진행됩니다.',
  requiredMsg: '는 필수로 입력해주셔야 합니다.',
  messageTypeChannelAlert: '메시지 유형이 "채널 추가형"으로 변경되어, \n첫번째 버튼의 타입이 "채널 추가"로 변경 입력되며\n기존 입력한 버튼 정보는 유지되지 않습니다.',

  registerCaption1: '알림톡 메시지는 카카오톡 채널을 추가하지 않은 이용자에게도 발송할 수 있는 정보성 메시지입니다. (광고성 메시지로는 사용할 수 없습니다.)',
  registerCaption2: '불법 스팸 방지를 위해, 심사를 통과한 템플릿만 발송할 수 있으며 템플릿 등록 후 반드시 ‘검수 요청’ 버튼을 눌러야 심사가 진행됩니다.',
  registerCaption3: '개인화된 텍스트 영역은 #{변수} 형태로 작성할 수 있습니다.',
  registerCaption3Sub: '(예 : 안녕하세요 #{Name}님. -> 안녕하세요 홍길동님.)',
  registerCaption4: '동일한 변수명이 여러 번 사용된 경우, 해당 변수에는 동일한 값이 일괄 적용됩니다.',
  registerCaption4Sub: '(예 : 안녕하세요 #{Name}님, #{Name}만을 위한 이벤트 입니다.)',
  registerCaption5: '개인화 텍스트 영역 사용가능 필드 :',
  registerCaption6: '템플릿 내용, 버튼명, 버튼링크',
  registerCaption7: '(아이템 리스트형 일 경우) 헤더 타이틀, 아이템 내용, 아이템 하이라이트 타이틀, 아이템 하이라이트 내용',
  businessFormOptions: {
    surveys: '톡에서 설문하기',
    applications: '톡에서 응모하기',
    reservations: '톡에서 예약하기',
  },
  businessFormType: '비즈니스 폼 유형',
  businessFormID: '비즈니스 ID',
  // 알림톡 메시지는 카카오톡 채널을 추가하지 않은 이용자에게도 발송할 수 있는 정보성 메시지입니다. (광고성 메시지로는 사용할 수 없습니다.)
  // 불법 스팸 방지를 위해, 심사를 통과한 템플릿만 발송할 수 있으며 템플릿 등록 후 반드시 ‘검수 요청’ 버튼을 눌러야 심사가 진행됩니다.

  // 개인화된 텍스트 영역은 #{변수} 형태로 작성할 수 있습니다.
  // (예 : 안녕하세요 #{Name}님. -> 안녕하세요 홍길동님.)
  // 동일한 변수명이 여러 번 사용된 경우, 해당 변수에는 동일한 값이 일괄 적용됩니다.
  // 예 : 안녕하세요 #{Name}님, #{Name}만을 위한 이벤트 입니다.

  // 개인화 텍스트 영역 사용가능 필드 :
  // 템플릿 내용, 버튼명, 버튼링크
  // (아이템 리스트형 일 경우) 헤더 타이틀, 아이템 내용, 아이템 하이라이트 타이틀, 아이템 하이라이트 내용

  // addChannelMessageCaption3: '채널 추가 버튼과 부가 정보를 함께 사용하고 싶으면 "복합형" 유형을 선택해주세요.',
};
